import { useEffect } from 'react';

const SITE_URL = 'https://avagyanlaw.com';

// Static firm/office data for schema.org JSON-LD.
// Keep in sync with public/locales/*/footer.json if office details change.
const STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Avagyan Law Firm',
      url: `${SITE_URL}/`,
      logo: `${SITE_URL}/logo512.png`,
      image: `${SITE_URL}/og-preview.png`,
      email: 'info@avagyanlaw.com',
      knowsAbout: ['Immigration Law', 'Personal Injury Law', 'Lemon Law', 'Employment Law'],
      sameAs: [
        'https://www.facebook.com/AvagyanLaw/',
        'https://www.instagram.com/avagyanlaw/',
        'https://www.tiktok.com/@avagyanlaw',
        'https://www.linkedin.com/company/avagyanlaw',
        'https://www.avvo.com/attorneys/91205-ca-tehmina-avagyan-5185982.html',
      ],
    },
    {
      '@type': 'LegalService',
      '@id': `${SITE_URL}/#glendale-office`,
      name: 'Avagyan Law Firm - Glendale Office',
      parentOrganization: { '@id': `${SITE_URL}/#organization` },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '600 N Brand Blvd Ste 570',
        addressLocality: 'Glendale',
        addressRegion: 'CA',
        postalCode: '91203',
        addressCountry: 'US',
      },
      telephone: '+1-805-600-0006',
      email: 'info@avagyanlaw.com',
      areaServed: ['Glendale, CA', 'Los Angeles County, CA', 'California'],
      availableLanguage: ['English', 'Spanish', 'Armenian', 'Russian'],
      url: `${SITE_URL}/en/`,
    },
    {
      '@type': 'LegalService',
      '@id': `${SITE_URL}/#sacramento-office`,
      // NOTE: footer labels this the "Sacramento Office" but the street address is
      // in Fair Oaks, CA. Keeping the physical address accurate here since mismatched
      // NAP (name/address/phone) data between schema, GBP, and directories hurts local SEO.
      name: 'Avagyan Law Firm - Sacramento Office',
      parentOrganization: { '@id': `${SITE_URL}/#organization` },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '9701 Fair Oaks Blvd.',
        addressLocality: 'Fair Oaks',
        addressRegion: 'CA',
        postalCode: '95628',
        addressCountry: 'US',
      },
      telephone: '+1-916-999-9909',
      email: 'info@avagyanlaw.com',
      areaServed: ['Sacramento, CA', 'Sacramento County, CA', 'California'],
      availableLanguage: ['English', 'Spanish', 'Armenian', 'Russian'],
      url: `${SITE_URL}/en/`,
    },
  ],
};

// Injects site-wide Organization + LegalService (per office) JSON-LD once.
// Mirrors SEOUpdater's imperative DOM approach so it survives react-snap prerendering.
const StructuredData = () => {
  useEffect(() => {
    let script = document.querySelector('script[data-structured-data="firm"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'firm');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(STRUCTURED_DATA);
  }, []);

  return null;
};

export default StructuredData;
